module.exports = __webpack_public_path__ + "img/组 66.84df02d1.png";